import {
    DELETE_IMAGE_SUCCESS,
    FETCH_IMAGES_AND_USER_SUCCESS,
    POPPING_ERROR,
    POPPING_FINISHED,
    POPPING_PROGRESS, PROCESSING_IMAGES_DRAG,
    PROCESSING_IMAGES_NAV,
    PROCESSING_IMAGES_TOGGLE,
    UPLOAD_ERROR,
    UPLOAD_FINISHED_FAILURE,
    UPLOAD_FINISHED_SUCCESS,
    UPLOAD_PROGRESS,
    UPLOAD_STARTED, UPLOADS_SELECTED,
} from '../actions/ImageActions';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import omit from 'lodash/omit';

const processingInitState = {uploadPct: 0, poppingPct: 0, uploadFinished: false};

function processingImageReducer(state, action) {
    const {uploadId} = action;
    switch (action.type) {
        case UPLOAD_STARTED: {
            return {...state, uploadId, uploadTime: Date.now()};
        }
        case UPLOAD_PROGRESS: {
            const {uploadPct} = action;
            return {...state, uploadPct};
        }
        case UPLOAD_FINISHED_SUCCESS: {
            return {...state, ...action.image, uploadPct: 100, uploadFinished: true};
        }
        case UPLOAD_FINISHED_FAILURE:
        case UPLOAD_ERROR: {
            const {error} = action;
            return {...state, error, uploadFinished: true};
        }
        case POPPING_PROGRESS: {
            const {id, enhId, poppingPct} = action;
            return {...state, id, enhId, poppingPct};
        }
        case POPPING_FINISHED: {
            const {id, enhId} = action;
            return {...state, id, enhId, uploadPct: 100, uploadFinished: true, poppingPct: 100, status: 'SUCCESS'};
        }
        case POPPING_ERROR: {
            const {error} = action;
            return {...state, error};
        }
        default:
            break;
    }
    return state;
}

function processingImagesReducer(state = {}, action) {
    const {uploadId} = action;
    if (uploadId) {
        if (action.type === DELETE_IMAGE_SUCCESS || action.type === POPPING_FINISHED) {
            return omit(state, uploadId);
        }
        const oldState = state[uploadId] || processingInitState;
        const newState = processingImageReducer(oldState, action);
        if (oldState !== newState) {
            return {...state, [uploadId]: newState};
        }
    }
    return state;
}

const PROCESSING_POSITION_KEY = 'processingPosition';

const initialPosition = JSON.parse(localStorage.getItem(PROCESSING_POSITION_KEY)) || {
    x: 0,
    y: 0,
};

const initialState = {
    items: {},
    lastFinishedId: null,
    showingIdx: 0,
    visible: false,
    position: initialPosition,
};

export function processingImages(state = initialState, action) {
    switch (action.type) {
        case UPLOADS_SELECTED: {
            return {...state, visible: true};
        }
        case PROCESSING_IMAGES_TOGGLE: {
            return {...state, visible: !state.visible};
        }
        case PROCESSING_IMAGES_NAV: {
            return {...state, showingIdx: action.idx};
        }
        case PROCESSING_IMAGES_DRAG: {
            const position = {x: action.x, y: action.y};
            localStorage.setItem(PROCESSING_POSITION_KEY, JSON.stringify(position));
            return {...state, position};
        }
        default:
            break;
    }

    let {items, lastFinishedId, visible} = state;

    if (action.type === FETCH_IMAGES_AND_USER_SUCCESS) {
        const unfinishedImages = filter(action.images, img => img.status !== 'SUCCESS' || img.error);
        const unfinishedImagesByUploadId = keyBy(map(unfinishedImages, img => ({uploadPct: 100, poppingPct: 0, ...img})), 'uploadId');
        items = {...items, ...unfinishedImagesByUploadId};
    } else {
        items = processingImagesReducer(items, action);
    }
    switch (action.type) {
        case POPPING_FINISHED: {
            lastFinishedId = action.id;
            if (isEmpty(items)) {
                visible = false;
            }
            break;
        }
        default:
            break;
    }
    return {...state, items, lastFinishedId, visible};
}



// WEBPACK FOOTER //
// ./src/reducers/processingImages.js